import React from 'react';

const SectionCard = ({ title, items }) => (
  <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 mb-10 hover:shadow-blue-500/30 transition duration-500">
    <h3 className="text-2xl font-semibold mb-6 text-blue-300 border-b border-blue-500 pb-2">
      {title}
    </h3>
    <ul className="list-disc list-inside text-blue-100 space-y-3 pl-2">
      {items.map((item, index) => (
        <li key={index} className="text-base leading-relaxed">
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const Achievements = () => {
  const responsibilities = [
    'Head of Technology, Weal – HealthTech Club, PES University',
    'Teaching Assistant – Mathematics for Computer Science Engineers, PES University',
    'Core Member – Event Management, Entrepreneurship Club, PES University',
    'Community Coordinator – StartupParty, Bengaluru',
    "Organized Heal-O-Code 2.0, Weal's Flagship HealthTech Hackathon with 50+ participating teams",
  ];

  const awards = [
    'Published research poster – AgentX: Automating AI Agent Creation with No-Code, Prompt-Driven Orchestration’ at 20th WiML Workshop, NeurIPS 2025- San Diego, California.',
    "1st Place - HACKEEE'4.0, PES University for Project- 'Belaku'",
    "Runner-up - Arithemania 3.0, PES University for Project- 'Unhigh-Gene'",
    'Runner-up – DSA-Triathlon Competitive Programming Contest, IIT Madras',
    'Won Internship Offer – Crime Investigation Department, Karnataka for HashProof',
    'National Semi-Finalist – EY Techathon 5.0',
    'Top 5 – Kochi Hackathon 2025 (AgentX project)',
    'Top 15 out of 6000+ – Rakathon 2024 (AgentX project)',
    'Top 10 out of 500+ – Hack4Soc 2.0 National Hackathon (SafePay project)',
    'Finalist – Mumbai DataHack 3.0, BuildwithDelhi, HackBangalore, Jagriti 2025 (IIT BHU), and more',
  ];

  return (
    <section id="achievements" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-4xl font-bold text-center text-blue-300 mb-16">
          Achievements
        </h2>
        <SectionCard title="Responsibilities" items={responsibilities} />
        <SectionCard title="Awards & Recognitions" items={awards} />
      </div>
    </section>
  );
};

export default Achievements;
